import { SVGProps } from "react";

export default function ErrorIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 14, width = 14, fill = "#DE1135", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M7.00016 13.4166C3.44183 13.4166 0.583496 10.5583 0.583496 6.99992C0.583496 3.44159 3.44183 0.583252 7.00016 0.583252C10.5585 0.583252 13.4168 3.44159 13.4168 6.99992C13.4168 10.5583 10.5585 13.4166 7.00016 13.4166ZM7.87516 2.91659H6.12516V7.58325H7.87516V2.91659ZM7.00016 8.74992C6.3585 8.74992 5.8335 9.27492 5.8335 9.91659C5.8335 10.5583 6.3585 11.0833 7.00016 11.0833C7.64183 11.0833 8.16683 10.5583 8.16683 9.91659C8.16683 9.27492 7.64183 8.74992 7.00016 8.74992Z"
        fill={fill}
      />
    </svg>
  );
}
